import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalWrapperComponent } from './components/modal-wrapper/modal-wrapper.component';
import { MatInputModule, MatDialogModule, MatExpansionModule } from '@angular/material';
import { FormModule } from '../form/form.module';
import { SharedModule } from '../../shared/shared.module';
import { FindParticipatingDealerComponent } from './components/find-participating-dealer/find-participating-dealer.component';
import { RegistrationComponent } from './components/registration/registration.component';
import { RegistrationSponsorComponent } from './components/registration-sponsor/registration-sponsor.component';
import { ShareComponent } from './components/share/share.component';
import { RequestInfoComponent } from './components/request-info/request-info.component';
import { FindParticipatingDealerMapComponent } from './components/find-participating-dealer-map/find-participating-dealer-map.component';
import { DynamicScriptLoaderService } from '../../services/dynamic-script-loader.service';
import { GoogleMapsService } from './services/google-maps.service';
import { DocumentRef, WindowRef } from './services/utils.service';
import { WhatIsIdmeComponent } from './components/what-is-idme/what-is-idme.component';
import { FaqComponent } from './components/faq/faq.component';
import { AlertMessageComponent } from './components/alert-message/alert-message.component';

@NgModule({
  imports: [
    CommonModule,
    MatInputModule,
    MatDialogModule,
    MatExpansionModule,
    SharedModule,
    FormModule
  ],
  declarations: [
    ModalWrapperComponent,
    RequestInfoComponent,
    FindParticipatingDealerComponent,
    FindParticipatingDealerMapComponent,
    RegistrationComponent,
    RegistrationSponsorComponent,
    ShareComponent,
    WhatIsIdmeComponent,
    FaqComponent,
    AlertMessageComponent
  ],
  exports: [
    ModalWrapperComponent,
  ],
  providers: [ DynamicScriptLoaderService, GoogleMapsService, WindowRef, DocumentRef],
  entryComponents: [ModalWrapperComponent]
})
export class ModalsModule { }
